const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

const formatDate = (inputDate, showHour = false) => {
  if (!inputDate) return "";

  inputDate = inputDate.replace(/-/g, "/");
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  let formattedDate;
  if (showHour) {
    formattedDate =
      months[month] + ", " + day + " " + year + " " + hour + ":" + minutes;
  } else {
    formattedDate = months[month] + ", " + day + " " + year;
  }
  return formattedDate;
};

export const formatDateWithHour = value => {
  return formatDate(value, true);
};
